import { CountyState } from "./types";

export const defaultState = (): CountyState => {
  return {
    editing: null,
    makingApiRequest: false,
    lastUpdate: new Date(),
    counties: [],
    links: {}
  };
};

export const state = defaultState();
